// @ts-expect-error [EN-7967] - TS2305 - Module '"@splitsoftware/splitio"' has no exported member 'Attributes'. | TS2305 - Module '"@splitsoftware/splitio"' has no exported member 'SplitClient'.
import type { Attributes, SplitClient } from '@splitsoftware/splitio';

import { logger } from '../logger';

/**
 * Overrides SplitClient's `getTreatment` to pull values from local storage
 * first. Applied by `getClientWithState` whenever the mock layer is enabled —
 * i.e. on non-production deployments (`DEPLOY_ENV !== 'production'`) or when
 * `E2E_TEST` / `LOCAL_SPLITS` is set. This allows the UAT tests to define
 * feature flags on a per-test basis by writing to local storage.
 */
export function makeGetTreatmentMockable(client: SplitClient): SplitClient {
  const originalGetTreatment = client.getTreatment;
  client.getTreatment = (splitName: string, attributes?: Attributes) => {
    let mocks: Record<string, any> = {};
    try {
      const mocksString = localStorage.getItem('__SIRONA_SPLIT_MOCKS__');
      if (typeof mocksString === 'string') {
        mocks = JSON.parse(mocksString);
      }
    } catch (e: any) {
      logger.warn('Failed to parse __SIRONA_SPLIT_MOCKS__ from localStorage', e);
    }

    if (splitName in mocks) {
      return mocks[splitName];
    }

    return originalGetTreatment(splitName, attributes);
  };
  return client;
}
